/**
 * El PIN personal del autorizador (PinAutorizadorService en CosRest).
 *
 * El PIN solo viaja de ida, en la petición que lo usa: ninguna respuesta
 * lo trae, y la pantalla no lo guarda en ningún lado.
 */
export interface PinAutorizadorReq {
  /** El PIN actual: para cambiarlo. */
  pin?: string;
  pinNuevo?: string;
  /** La contraseña de COS: para definirlo la primera vez. */
  password?: string;
  /** De quién: solo para Empleados (estado y restablecer). */
  idUsuario?: number;
}

export interface PinAutorizadorRes {
  tienePin?: boolean;
  /** «14:35» si está bloqueado; nulo si no. */
  bloqueadoHasta?: string | null;
  intentosRestantes?: number | null;
  /** Si su perfil tiene alguna llave que pide PIN (de cualquier módulo): puede definirlo. */
  puedeAutorizar?: boolean;
  codigoError?: string;
  mensajeError?: string;
}

/** Los largos que acepta el servidor. */
export const PIN_MIN = 6;
export const PIN_MAX = 8;

/**
 * Las mismas reglas que PinAutorizadorBuss.exigeReglas, para avisar antes
 * de mandar. El servidor las vuelve a revisar: esto solo ahorra una vuelta.
 *
 * @returns el problema, o null si el PIN cumple.
 */
export function problemaDelPin(pin: string): string | null {
  if (!new RegExp(`^\\d{${PIN_MIN},${PIN_MAX}}$`).test(pin)) {
    return `El PIN va de ${PIN_MIN} a ${PIN_MAX} dígitos.`;
  }
  let iguales = true;
  let sube = true;
  let baja = true;
  for (let i = 1; i < pin.length; i++) {
    const antes = pin.codePointAt(i - 1);
    const ahora = pin.codePointAt(i);
    iguales = iguales && ahora === antes;
    sube = sube && ahora === antes + 1;
    baja = baja && ahora === antes - 1;
  }
  if (iguales) {
    return "El PIN no puede ser un solo dígito repetido.";
  }
  if (sube || baja) {
    return "El PIN no puede ser una escalera como 123456 o 987654.";
  }
  return null;
}

/** Deja solo dígitos y corta al máximo: para el (input) de los campos de PIN. */
export function soloDigitos(valor: string | null | undefined): string {
  return String(valor ?? "").replace(/\D+/g, "").slice(0, PIN_MAX);
}
